
import { defineComponent } from 'vue';
import utilities from '@/Utilities/common';

import PrzItem from '../AbstractItem/Component.vue';
import PrzInfo from '../Parts/ProductInfo/Component.vue';
import PrzLabel from '../Parts/ProductLabel/Component.vue';
import PrzPicture from '@/components/Muffin/Picture.vue';
import PrzBgVideo from '@/components/Blocks/Singles/Parts/BackgroundVideo/Component.vue';
import { BlockEvents } from '@/models/Blocks/block-events';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockProduct } from '@/models/Blocks/Itens/block-product';
import { BlockItemPrice, BlockItemPriceType } from "@/models/Blocks/Itens/Types/block-item-price";

export default defineComponent({
    components:{
        PrzItem,
        PrzInfo,
        PrzLabel,
        PrzPicture,
        PrzBgVideo
    },
    props:{
        item:{
            type: BlockItem,
        }
    },
    data(){
        let timeout: any = undefined;
        return {
            opacity: 0,
            videoPlay: false,
            timeout
        }
    },
    computed:{
        product(): BlockProduct|null{
            return this.item instanceof BlockProduct ? <BlockProduct>this.item : null;
        },
        variant(): string|undefined{
            return this.product?.variant ?? undefined;
        },
        prices(): Array<BlockItemPrice>|undefined{
            let prs = new Array<BlockItemPrice>();
            if(this.product == null){
                return prs;
            }
            prs.push({type: BlockItemPriceType.real,price: this.product.price.value});
            if(this.product.price.crossed){
                prs.push({type: BlockItemPriceType.strikethrough,price: this.product.price.crossed});
            }
            return  prs;
        }
    },
    methods: {
        clickProduct(){
            BlockEvents.AddProductClick(this.$el,{item: this.item});
            if(this.product && this.product.page && this.product.groupId){
                // Sergio, Check This Please
                // const urlLocation = new URL(location);
                // urlLocation.searchParams.set('page', this.product.page);
                // urlLocation.searchParams.set('data-anchor', this.product.groupId);
                // history.pushState({}, "", urlLocation);
                // history.replaceState({}, '', "?page=" + this.product.page + "&data-anchor=" + this.product.groupId);

                if(utilities.storageAvailable("sessionStorage")) { 
                    sessionStorage.setItem('catalogAnchor', JSON.stringify({url: window.location.href, groupId: this.product.groupId}));
                }
            }
        },
        mouseEvent(hover: boolean){
            this.opacity = hover ? 1 : 0;
            if(this.timeout){
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                this.videoPlay = hover;
            }, 100);
        }
    },
});
